import { memo } from "react";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import StickyNoteLineIcon from "remixicon-react/StickyNoteLineIcon";
import { Controller } from "react-hook-form";
import { InfoContainer, Text } from "$components";
import { TitleInfoContainer } from "$components/InfoContainer/TitleInfoContainer";
import { ButtonEditInfoContainer } from "$components/InfoContainer/ButtonEditInfoContainer";
import { useStyles } from "./CompanyProfile.styles";
import FileUploader from "$components/FileUploader/FileUploader";
import useAuth from "$hooks/useAuth";
import EntrepriseForm from "../EntrepriseForm";
import useCompanyForm from "$hooks/useCompanyForm";
import { usePopin } from "$components/Popin/usePopin";

export const AgenciesBottomBlock = memo(function AgenciesBottomBlock({
  control,
  company,
  fetchCompany,
}: any) {
  const classes = useStyles();
  const { isAdmin } = useAuth(); // will be remove with acl

  const { Popin, openPopin, togglePopin, PopinProps } = usePopin();

  // @todo amir: why it's useless ? we still need it to make the component reusable !
  // TODO will remove this with the form update, it's useless
  const { handleSubmit, error, submitting } = useCompanyForm(fetchCompany);

  return (
    <>
      <InfoContainer
        className={classes.fullWidthContainer}
        leftHeader={
          <TitleInfoContainer
            title="Pièces jointes"
            icon={<AttachFileIcon />}
          />
        }
      >
        <form>
          <Controller
            control={control}
            name="medias"
            render={({ field: { onChange, value } }) => (
              <FileUploader
                value={value}
                onChange={(values) => {
                  onChange(values);
                }}
                isAdmin={isAdmin()}
                type="company"
                company={company?._id}
                id={company?._id ?? undefined}
                isEdit={false}
                isLargeVersion
              />
            )}
          />
        </form>
      </InfoContainer>

      <InfoContainer
        className={classes.fullWidthContainer}
        leftHeader={
          <TitleInfoContainer title="Caractéristiques techniques de prise en charge" />
        }
        rightHeader={<ButtonEditInfoContainer onClick={openPopin} />}
      >
        <Text>
          {company.technicalNotes || (
            <i>Aucune caractéristique de prise en charge saisie</i>
          )}
        </Text>
      </InfoContainer>

      <InfoContainer
        className={classes.fullWidthContainer}
        leftHeader={
          <TitleInfoContainer title="Remarques" icon={<StickyNoteLineIcon />} />
        }
        rightHeader={
          <ButtonEditInfoContainer
            onClick={openPopin}
            className={company?.isActive === false ? classes.disabledCta : ""}
          />
        }
      >
        <Text>{company.notes || <i>Aucune remarque saisie</i>}</Text>
      </InfoContainer>
      <Popin {...PopinProps}>
        <EntrepriseForm
          onSubmit={handleSubmit}
          onReset={togglePopin}
          companyError={error}
          isSubmitting={submitting}
          defaultValues={{
            ...company,
            sector: company?.sector as any,
          }}
        />
      </Popin>
    </>
  );
});
